import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingPanelComponent } from './floating-panel.component';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule } from '../button';

@NgModule({
  declarations: [FloatingPanelComponent],
  imports: [CommonModule, MatIconModule, ButtonModule],
  exports: [FloatingPanelComponent],
})
export class FloatingPanelModule {}
